import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/expense/createaction";
import Expenselist from "./expenselist";
import getaction from "../../context/action/expense/getaction";

const Expense = () => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
  const [expense_amount, setexpense_amount] = useState();
  const [expense_type_id, setexpense_type_id] = useState("null");
  const [expense_date, setexpense_date] = useState();
  const [expense_note, setexpense_note] = useState();

  const [from, setfrom] = useState();
  const [to, setto] = useState();
  const [expense_type_id_read, setexpense_type_id_read] = useState("null");

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);
  const [error4, seterror4] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">خەرجی</h1>
          <p className="text-sm text-slate-400 mt-0.5">بەڕێوەبردنی خەرجی</p>
        </div>
      </div>

      {/* Add New Expense Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 items-end">
        <div className="w-full">
          <label
            className={
              error
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="expense_amount"
          >
            بڕی خەرجی
          </label>
          <input
            className={
              error
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="expense_amount"
            type="number"
            placeholder=""
            onClick={(val)=>{val.target.select()}}
            value={expense_amount}
            onChange={(val) => setexpense_amount(val.target.value)}
            onFocus={() => seterror(false)}
          />
        </div>
        <div className="w-full">
          <label
            htmlFor="cate"
            className={
              error1
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
          >
            جۆری خەرجی
          </label>
          <select
            id="cate"
            className={
              error1
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-red-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            value={expense_type_id}
            onChange={(val) => {
              seterror1(false);
              setexpense_type_id(val.target.value);
            }}
          >
            <option value="null">جۆری خەرجی هەڵبژێرە</option>
            {initState.active_expense_type.map((lis) => (
              <option value={lis.expense_type_id}>
                {lis.expense_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="w-full">
          <label
            className={
              error4
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="expense_date"
          >
            بەروار
          </label>
          <input
            className={
              error4
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="expense_date"
            type="date"
            placeholder=""
            onClick={(val)=>{val.target.select()}}
            value={expense_date}
            onChange={(val) => setexpense_date(val.target.value)}
            onFocus={() => seterror4(false)}
          />
        </div>
        <div className="w-full">
          <label
            className="block text-sm font-medium text-slate-500 mb-1 text-right"
            htmlFor="note"
          >
            تێبینی
          </label>
          <input
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            id="note"
            type="text"
            placeholder=""
            onClick={(val)=>{val.target.select()}}
            value={expense_note}
            onChange={(val) => setexpense_note(val.target.value)}
          />
        </div>
        <div className="w-full">
          <button
            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
            onClick={() => {
              if (expense_amount == "" || !expense_amount) {
                seterror(true);
                return false;
              }
              if (expense_type_id == "null" || !expense_type_id) {
                seterror1(true);
                return false;
              }
              createaction(
                expense_amount,
                expense_type_id,
                expense_date,
                expense_note,
                initState.token.user_id
              )(recaller)(setrecaller)(initDispatch)(clear);
            }}
          >
            زیادکردن
          </button>
        </div>
      </div>
      </div>

      {/* Expense List Filter Section */}
      <div className="mt-8">
        <h2 className="text-lg font-bold text-slate-800 mb-6">لیستی خەرجی</h2>
        <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
        <div className="w-full">
          <label
            className={
              error2
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="date_from"
          >
            لە بەرواری
          </label>
          <input
            className={
              error2
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="date_from"
            type="date"
            placeholder=""
            value={from}
            onChange={(val) => setfrom(val.target.value)}
            onFocus={() => seterror2(false)}
          />
        </div>
        <div className="w-full">
          <label
            className={
              error3
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
            htmlFor="date_to"
          >
            بۆ بەرواری
          </label>
          <input
            className={
              error3
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            id="date_to"
            type="date"
            placeholder=""
            value={to}
            onChange={(val) => setto(val.target.value)}
            onFocus={() => seterror3(false)}
          />
        </div>
        <div className="w-full">
          <label
            htmlFor="expense_type_id_read"
            className="block text-sm font-medium text-slate-500 mb-1 text-right"
          >
            جۆری خەرجی
          </label>
          <select
            id="expense_type_id_read"
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            value={expense_type_id_read}
            onChange={(val) => {
              setexpense_type_id_read(val.target.value);
            }}
          >
            <option value="null">جۆری خەرجی هەڵبژێرە</option>
            {initState.active_expense_type.map((lis) => (
              <option value={lis.expense_type_id}>
                {lis.expense_type_name}
              </option>
            ))}
          </select>
        </div>
        <div className="w-full">
          <button
            className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
            onClick={() => {
              if (from == "" || !from) {
                seterror2(true);
                return false;
              }
              if (to == "" || !to) {
                seterror3(true);
                return false;
              }
              getaction(from, to, expense_type_id_read)(recaller)(setrecaller)(initDispatch)(clear);
            }}
          >
            گەڕان
          </button>
        </div>
        </div>
        </div>
      </div>

      {/* Expense List Section */}
      <Expenselist />
    </div>
  );
};

export default Expense;
